/* eslint-disable @atlassian/relay/must-use-inline, @atlassian/relay/graphql-naming, @atlassian/relay/unused-fields -- Shared resource operations and canonical snapshots are consumed by the resource owner, readers, and store reconciliation. */
import { graphql } from 'react-relay';
import type { GraphQLTaggedNode } from 'relay-runtime';

export const agentSessionsMainQuery: GraphQLTaggedNode = graphql`
	query agentSessionsMainQuery(
		$sharingContext: String!
		$aqlQuery: String!
		$count: Int!
		$after: String
	) {
		...agentSessionsMainQuery_query
			@arguments(sharingContext: $sharingContext, aqlQuery: $aqlQuery, count: $count, after: $after)
	}
`;

export const agentSessionsMainFragment: GraphQLTaggedNode = graphql`
	fragment agentSessionsMainQuery_query on Query
	@argumentDefinitions(
		sharingContext: { type: "String!" }
		aqlQuery: { type: "String!" }
		count: { type: "Int", defaultValue: 25 }
		after: { type: "String" }
	)
	@refetchable(queryName: "agentSessionsMainPaginationQuery") {
		agent_sessionQuery(
			shardingContext: $sharingContext
			aqlQuery: $aqlQuery
			sort: "lastStateChangeAt DESC"
			first: $count
			after: $after
		)
			@connection(
				key: "agentSessionsMain_agent_sessionQuery"
				filters: ["shardingContext", "aqlQuery", "sort"]
			) {
			edges {
				node {
					hasUnseenActivity
					invocationType
					...agentSessionSnapshot_session @relay(mask: false)
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;
